import { Grid } from '../board';

export function findMaxElementInMatrix(grid: Grid) {
    let position = { i: 0, j: 0 }, maxValue = 0;

    for (let i = 0; i < grid.length; i++) {
        for (let j = 0; j < grid[0].length; j++) {
            if (Number(grid[i][j]) > maxValue) {
                maxValue = Number(grid[i][j]);
                position = { i, j };
            }
        }
    }

    return {
        maxValue,
        position
    };
}